export enum ShiftTypeEnum {
  Full = 1,
  Morning,
  Afternoon,
  FreeHour
}
